// eslint-disable-next-line @typescript-eslint/naming-convention
export enum socialFiltersEnum {
    subscriptions = 'subscriptions',
    dateRange = 'dateRange',
    networkType = 'mediaTypes', // must match monitoringFiltersEnum.mediaTypes
    mediaContent = 'mediaContent',
    tags = 'tags',
    tagGroups = 'tagGroups',
    prominence = 'prominence',
    agents = 'agents',
}
